(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["garage-sale"] && !Shopify.designMode) return;
  try {
    
  if (!window.customElements.get('gs-countdown')) {
    window.customElements.define('gs-countdown', class extends HTMLElement {
      connectedCallback() {
        this.end = new Date(this.dataset.end).getTime();
        this.start = this.dataset.start ? new Date(this.dataset.start).getTime() : NaN;
        if (Number.isNaN(this.end)) {
          this.hidden = true;
          return;
        }
        this.labelElement = this.querySelector('[data-label]');
        this.tick();
        this.timer = window.setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        window.clearInterval(this.timer);
      }

      tick() {
        const now = Date.now();
        let target = this.end;
        let label = this.dataset.labelEnd;

        if (!Number.isNaN(this.start) && now < this.start) {
          target = this.start;
          label = this.dataset.labelStart || label;
        }

        const diff = target - now;

        if (diff <= 0) {
          window.clearInterval(this.timer);
          this.classList.add('is-expired');
          const expired = this.querySelector('[data-expired]');
          if (expired) {
            expired.hidden = false;
          } else {
            const bar = this.closest('.gs-bar');
            (bar || this).hidden = true;
          }
          return;
        }

        if (this.labelElement && this.labelElement.textContent !== label) {
          this.labelElement.textContent = label;
        }

        const values = {
          days: Math.floor(diff / 86400000),
          hours: Math.floor(diff / 3600000) % 24,
          minutes: Math.floor(diff / 60000) % 60,
          seconds: Math.floor(diff / 1000) % 60
        };

        Object.keys(values).forEach((unit) => {
          const element = this.querySelector(`[data-unit="${unit}"]`);
          if (element) element.textContent = String(values[unit]).padStart(2, '0');
        });
      }
    });
  }

  if (!window.customElements.get('gs-nav')) {
    window.customElements.define('gs-nav', class extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('.gs-nav__list');
        this.links = Array.from(this.querySelectorAll('a[href^="#"]'));
        this.root = this.closest('.gs') || document.documentElement;

        this.updateHeight = () => this.root.style.setProperty('--gs-nav-height', `${this.offsetHeight}px`);
        this.updateHeight();
        window.addEventListener('resize', this.updateHeight);

        this.onClick = (event) => {
          const link = event.target.closest('a[href^="#"]');
          if (!link) return;
          const target = document.getElementById(link.getAttribute('href').slice(1));
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          history.replaceState(null, '', link.getAttribute('href'));
        };
        this.addEventListener('click', this.onClick);

        const targets = this.links
          .map((link) => document.getElementById(link.getAttribute('href').slice(1)))
          .filter(Boolean);

        if ('IntersectionObserver' in window && targets.length > 0) {
          this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) this.setActive(entry.target.id);
            });
          }, { rootMargin: '-35% 0px -60% 0px' });
          targets.forEach((target) => this.observer.observe(target));
        }
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.updateHeight);
        this.removeEventListener('click', this.onClick);
        if (this.observer) this.observer.disconnect();
      }

      setActive(id) {
        this.links.forEach((link) => {
          const active = link.getAttribute('href') === `#${id}`;
          link.setAttribute('aria-current', active ? 'true' : 'false');
          if (active && this.list && this.list.scrollWidth > this.list.clientWidth) {
            this.list.scrollTo({ left: link.parentElement.offsetLeft - 16, behavior: 'smooth' });
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
